// Survey stats (stats.rs): POST /v1/surveys/{surveyId}/stats with the same
// typed filters as the responses search, so a segment's numbers match the
// list. The server derives the trend window from the time filters.

import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { http } from "./http";
import { statsKeys } from "./keys";
import type { ResponseSearchFilters } from "./responses";
import type { SurveyStats } from "./types";

export interface StatsRq {
    filters: ResponseSearchFilters;
    splitByPlacement?: boolean;
}

/** `rq: null` holds the request back (no fetch), like `useResponseSearch`. */
export function useStats(surveyId: string, rq: StatsRq | null) {
    return useQuery({
        queryKey: statsKeys.detail(surveyId, rq),
        queryFn: () => http.post<SurveyStats>(`/v1/surveys/${surveyId}/stats`, { json: rq }),
        enabled: Boolean(surveyId) && rq !== null,
        // A filter change is a new query key (rq is part of it), so without
        // this the dashboard would blank to a loading state on every filter
        // tweak. `keepPreviousData` holds the prior segment's stats on screen
        // until the new one resolves — same idiom as useResponseSearch.
        placeholderData: keepPreviousData,
    });
}
